var SinglePntyJob = {};

(function ( $ ) {
    var scope = $( '.single-pnty_job' ), applyButton = $( '.js-apply-button' ), interval;

    SinglePntyJob.init = function () {
        $( '.pnty-job img' ).on( 'error', function () {
            var element = $( this );

            // Replace image with company name
            var company = element.prop( 'alt' );
            element.parent().prepend( '<h2 class="text-center">' + company + '</h2>' );

            element.off( 'error' );
            element.remove();
        } );

        if ( applyButton.length !== 0 ) {
            interval = setInterval( function () {
                applyButton.each( function () {
                    var link = $( this ).find( 'link' ), button = $( this ).find( '.pnty-btn' );

                    if ( link.length === 0 && button.length === 0 ) {
                        return;
                    }

                    link.remove();
                    button.addClass( 'btn btn-secondary' );
                    $( this ).removeClass( 'hide' );
                    clearInterval( interval );
                } );
            }, 1000 );
        }
    };

    if ( scope.length ) {
        $( SinglePntyJob.init );
    }
})( jQuery );